<template>
    <div class="search-area">
        <div  style="padding:8px 0px; display: flex;align-items: center; ">

           <el-form class="demo-form-inline" style="width:100%;">
                <div style="width:100%;display:flex;align-items: center;">
                    <div style="width:70%;display:flex;align-items: center; justify-content: flex-start; ">
                        <div class="input-group-search" >
                          <el-input
                            id="title"
                            v-model="searchParam.title"
                            class="input-field"
                            clearable
                            style="width:260px;"
                            placeholder=" "
                          />
                          <label for="title" class="floating-label">标题</label>
                        </div>
                        
                        <div class="input-group" style="width: 260px;" :class="{ 'has-value': searchParam.status !== '' }">
                            <el-select
                              v-model="searchParam.status"
                              id="status1"
                              class="select-field"
                              style="width:260px;"
                              clearable
                              placeholder=" "
                            >
                              <el-option
                                v-for="item in statusOpt"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                            <label for="loginAccount1" class="floating-label1">开启状态</label>
                        </div>

                    </div>
                    <div style="width:30%;text-align:right; font-size: 24px; cursor: pointer;">

                        <el-tooltip class="item" effect="dark"  content="新增" placement="bottom">
                            <i class="el-icon-plus" @click="addOpenDrawer" ></i>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark"  content="刷新" placement="bottom">
                            <i class="el-icon-refresh" @click="getPage" ></i>
                        </el-tooltip>

                    </div>

                </div>

            </el-form>

        </div>


       <el-table class="table-data" :data="tableData" :height="tableHeight"  style="width:100%; margin-bottom: 10px; ">

          <el-table-column
                prop="sysMessageId"
                label="ID"
                width="50"
                >
         </el-table-column>
        <el-table-column
                prop="title"
                label="标题"
                 width="250"
                >
         </el-table-column>
         <el-table-column
                prop="connect"
                label="内容"
                width="400"
                >
         </el-table-column>
         <el-table-column
                prop="status"
                label="开启状态"
                 width="100"
                >
                <template slot-scope="scope">
                  <el-switch
                  v-model="scope.row.btnStatus"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                   @change="showStatusTip(scope.$index)"
                  >
                </el-switch>
                
                </template>
         </el-table-column>
         <el-table-column
                prop="sumCount"
                label="总计"
                width="60"
                >
         </el-table-column>
         <el-table-column
                prop="unReadCount"
                label="未读"
                width="60"
                >
         </el-table-column>
         <el-table-column
                prop="readCount"
                label="已读"
                width="60"
                >
         </el-table-column>
          <el-table-column
                prop="loginAccount"
                label="创建账号"
                width="150"
                >
         </el-table-column>
         <el-table-column
                prop="createTime"
                label="创建时间"
                >
         </el-table-column>

            <el-table-column
                    label="操作"
                    fixed="right"
                    width="200"
                    >
                <template slot-scope="scope">
                    <el-tooltip class="item table-btn-icon" effect="dark" content="查看详情" placement="bottom">
                        <i class="el-icon-edit table-icon" @click="getId(scope.row)"></i>
                    </el-tooltip> 
                    <el-tooltip class="item table-btn-icon" effect="dark" content="用户列表" placement="bottom">
                        <i class="el-icon-user table-icon" @click="showUserDrawer(scope.row.sysMessageId)"></i>
                    </el-tooltip>
                    
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                @next-click="nextClick"
                @prev-click="prevClick"
                :current-page="pageUtil.curPage"
                :page-sizes="[20, 30, 50, 100,200]"
                :page-size="pageUtil.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageUtil.total"
                style="height: 30px; line-height: 30px; margin:10px auto; text-align: center;">
        </el-pagination>

        <el-drawer
          title="编辑"
          :visible.sync="isOpenDrawer"
          :wrapperClosable="false"
          direction="rtl"
          :before-close="handleClose">
           <!-- 使用flex布局确保底部固定 -->
          <div class="drawer-container">
            <!-- 可滚动的内容区域 -->
            <div class="drawer-content">
              <!-- <span>我来啦!</span> -->
              <!-- 这里可以放置您的表单或其他内容 -->
              <!-- <div style="height: 1500px; background: #f5f5f5; margin-top: 20px;">
                模拟长内容区域
              </div> -->

              <el-form  ref="loginForm" >

             
             <div class="input-group" >
               <el-form-item prop="title" >
                    <el-input type="text" id="title" v-model="sysNoticeMessage.title" class="input-field" placeholder=" " />
                     <label for="title" class="floating-label">公告标题</label>
               </el-form-item>
             </div>

             <div class="input-group m-top20">
                  <el-form-item prop="connect" >
                      <el-input
                      type="textarea"
                      :rows="5"
                      placeholder="* 公告内容"
                      v-model="sysNoticeMessage.connect">
                    </el-input>
                       
                  </el-form-item>
                </div>

             <div class="input-group"  v-if="optBtnStatus == 'update'">
               <el-form-item prop="loginAccount" >
                    <el-input type="text" id="loginAccount" v-model="sysNoticeMessage.loginAccount" disabled="false" class="input-field" placeholder=" " />
                     <label for="loginAccount" class="floating-label">发送者账号</label>
               </el-form-item>
             </div>

            <div class="input-group"  v-if="optBtnStatus == 'update'">
               <el-form-item prop="btnStatus" >
                    <el-input type="text" id="btnStatus" v-model="sysNoticeMessage.btnStatus" disabled="false" class="input-field" placeholder=" " />
                     <label for="status" class="floating-label">状态</label>
               </el-form-item>
             </div>

              <div class="input-group" v-if="optBtnStatus == 'update'" >
               <el-form-item prop="createTime" >
                    <el-input type="text" id="createTime" v-model="sysNoticeMessage.createTime" disabled="false" class="input-field" placeholder=" " />
                     <label for="createTime" class="floating-label">创建时间</label>
               </el-form-item>
             </div>


              </el-form>


            </div>

            <!-- 固定的底部按钮区域 -->
            <div class="drawer-footer">
              <el-button type="primary" @click="save">保存</el-button>
            </div>
          </div>

        </el-drawer>

           <!-- 显示用户列表 -->
         <el-drawer
          title="查看"
          :visible.sync="userDrawer"
           size='40%'
          :wrapperClosable="false"
          direction="rtl"
          :before-close="false">
           <!-- 使用flex布局确保底部固定 -->
          <div class="drawer-container">
            <!-- 可滚动的内容区域 -->
            <div class="drawer-content" >
              <!-- <span>我来啦!</span> -->
              <!-- 这里可以放置您的表单或其他内容 -->
              <!-- <div style="height: 1500px; background: #f5f5f5; margin-top: 20px;">
                模拟长内容区域
              </div> -->
              
              <div  style="padding:8px 0px; display: flex;align-items: center; ">

           <el-form class="demo-form-inline" style="width:100%;">
                <div style="width:100%;display:flex;align-items: center;">
                    <div style="width:70%;display:flex;align-items: center; justify-content: flex-start; ">
                        <div class="input-group-search" >
                          <el-input
                            id="searchName"
                            v-model="searchUserParam.name"
                            class="input-field"
                            clearable
                            style="width:260px;"
                            placeholder=" "
                          />
                          <label for="searchName" class="floating-label">昵称或者姓名</label>
                        </div>
                        
                        <div class="input-group" style="width: 260px;" :class="{ 'has-value': searchUserParam.isRead !== '' }">
                            <el-select
                              v-model="searchUserParam.isRead"
                              id="searchIsRead"
                              class="select-field"
                              style="width:260px;"
                              clearable
                              placeholder=" "
                            >
                              <el-option
                                v-for="item in readOpt"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                            <label for="loginAccount1" class="floating-label1">阅读状态</label>
                        </div>

                    </div>
                    <div style="width:30%;text-align:right; font-size: 24px; cursor: pointer;">

                        <el-tooltip class="item" effect="dark"  content="刷新" placement="bottom">
                            <i class="el-icon-refresh" @click="getUserPage" ></i>
                        </el-tooltip>

                    </div>

                </div>

            </el-form>

        </div>

                <el-table
                :data="userTableData"
                stripe
                style="width: 100%">
                <el-table-column
                  prop="nickName"
                  label="昵称"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="isRead"
                  width="120"
                  label="是否已读">
                </el-table-column>
                 <el-table-column
                  prop="readTime"
                  label="读取时间">
                </el-table-column>
              </el-table>
           
              
            </div>
            
            <!-- 固定的底部按钮区域 -->
            <div class="drawer-footer">
               <el-pagination
                @size-change="userHandleSizeChange"
                @current-change="userHandleCurrentChange"
                @next-click="userNextClick"
                @prev-click="userPrevClick"
                :current-page.sync="userPageUtil.curPage"
                :page-size="userPageUtil.pageSize"
                layout="total, prev, pager, next"
                :total="userPageUtil.total">
               </el-pagination>
            </div>
          </div>

        </el-drawer>
     </div>


  </template>

<script>



  var _this;
export default {
  name: 'Role',
  data () {
    return {
      tableHeight: 200,
      pageUtil:{total:0,pageSize:20,curPage:1},
      tableData:[],
      searchParam:{
          title: '',
          status: ''
      }, statusOpt: [
         { value: 0, label: '开启'},
         { value: 1, label: '关闭'}
      ],
      isOpenDrawer:false,
      optBtnStatus:'',
      optBtnInfo:{},
      sysNoticeMessage:{"loginAccount":"","sysMessageId":"","createTime":"","isDelete":"","connect":""},
      dialogVisible: false,
      userDrawer:false,
      userPageUtil:{total:0,pageSize:20,curPage:1},
      searchUserParam:{
        sysMessageId:-1,
        name:"",
        isRead:""
      },readOpt:[
        { value: 0, label: '未读'},
        { value: 1, label: '已读'}
      ],userTableData:[]

    }
  }, mounted(){

    //_this.initContentHeight(_this);
      _this.$com.initContentHeight(_this);
      _this.getPage();

  },created: function () {
      _this = this;

  },methods:{

     getPage(){

       try {

            var param = _this.searchParam;

            param['pageSize'] = _this.pageUtil.pageSize;
            param['curPager'] = _this.pageUtil.curPage;
          
            _this.$http.get('/back_bin/sys_notice/get_page', param,(response)=>{

            _this.pageUtil.total = response.data.countSum;
            _this.pageUtil.curPage = response.data.curPager;
            let list = response.data.list;
            if(list!=null && list.length > 0){

              for(let i=0;i<list.length;i++){

                let bean = list[i];
                bean.createTime = _this.$com.dateConvertTime(bean.createTime);

                if(bean.status == 0){
                  bean.btnStatus = true;
                }else if(bean.status == 1){
                  bean.btnStatus = false;
                }

              }

            }

            _this.tableData = list;
             console.info('请求结果1:', response )
            if(response .status == 'success'){


            }

            });

          } catch (error) {
            console.error('请求失败:', error)
          }


        },nextClick:function(){

            _this.pageUtil.curPage = _this.pageUtil.curPage+1;
            _this.getPage();

        },prevClick:function(){

            _this.pageUtil.curPage = _this.pageUtil.curPage-1;
            _this.getPage();

        },handleSizeChange:function(val) {

            _this.pageUtil.pageSize = val;

        },handleCurrentChange:function(val) {

            _this.pageUtil.curPage = val;
            _this.getPage();

        },addOpenDrawer:function(){

          _this.optBtnStatus = 'add';
           _this.resetForm();
           _this.isOpenDrawer = true;

        },handleClose:function(){

          _this.isOpenDrawer = false;

        },showStatusTip:function(index){
           
           let bean = _this.tableData[index];

           let optOldStatus = -1;
           let optStatus = '';
           let message = '';
           
           if(bean.status == 0){
              optOldStatus = true;
              message = '确认关闭该公告吗？';
              optStatus = 'close';
           }else{

             optOldStatus = false;
             message = '确认开启该公告吗？';
             optStatus = 'open';
           }

           _this.$confirm(message, '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
                 }).then(() => {

                    var param = {sysMessageId:bean.sysMessageId,optStatus:optStatus};

                   _this.$http.post('/back_bin/sys_notice/update_status', param,function(msg){

                     _this.$message({
                       type: 'success',
                       message:'操作成功!'
                     });

                    _this.getPage();

                   });

                 }).catch(() => {
                  // 用户取消，回滚状态
                  bean.btnStatus = optOldStatus;
                  
                });



        },save(){

            if(_this.optBtnStatus == 'add'){
              _this.add();
            }else if(_this.optBtnStatus == 'update'){
               _this.update();
            }

        },async add(){

           try {

              var param = _this.sysNoticeMessage;
              
              const response = await _this.$http.syncPost('/back_bin/sys_notice/add', param);
              if(response.status == 'success'){

                  _this.isOpenDrawer = false;
                  _this.$message({
                    message: '新增成功!',
                    type: 'success'
                  });

                  _this.getPage();

              }
              console.info('请求结果1:', response )

            } catch (error) {
              console.error('请求失败:', error)
            }

        },async update(){

           try {

              var param = _this.sysNoticeMessage;
              const response = await _this.$http.syncPost('/back_bin/sys_notice/update', param);
              if(response.status == 'success'){

                  _this.isOpenDrawer = false;
                  _this.$message({
                    message: '修改成功!',
                    type: 'success'
                  });

                  _this.getPage();

              }
              console.info('请求结果1:', response )

            } catch (error) {
              console.error('请求失败:', error)
            }

        },async getId(row){

           try {
              _this.optBtnStatus = 'update';
              _this.resetForm();
              var param = {'keyId':row.sysMessageId};

              const response = await _this.$http.syncGet('/back_bin/sys_notice/get_by_id', param);
              if(response.status == 'success'){

                  _this.isOpenDrawer = true;
                   let sysNoticeMessage = response.data;

                sysNoticeMessage.createTime = _this.$com.dateConvertTime(sysNoticeMessage.createTime);

                if(sysNoticeMessage.status == 0){
                  sysNoticeMessage.btnStatus = '开启';
                }else if(sysNoticeMessage.status == 1){
                  sysNoticeMessage.btnStatus = '关闭';
                }

                  _this.sysNoticeMessage = sysNoticeMessage;

              }
              console.info('请求结果1:', response )

            } catch (error) {
              console.error('请求失败:', error)
            }

        },resetForm(){

           _this.dialogVisible = false;
            // 2. 关闭预览对话框
            _this.dialogVisible = false;
          _this.sysNoticeMessage = {"loginAccount":"","sysMessageId":"","createTime":"","isDelete":"","connect":""}

        },showUserDrawer:function(sysMessageId){

           _this.searchUserParam['sysMessageId'] = sysMessageId;
           _this.userDrawer = true;

           _this.getUserPage();


        }, getUserPage(){

         try {

            var param = _this.searchUserParam;

            param['pageSize'] = _this.userPageUtil.pageSize;
            param['curPager'] = _this.userPageUtil.curPage;
          

            _this.$http.get('/back_bin/sys_notice/get_user_page', param,(response)=>{

            _this.userPageUtil.total = response.data.countSum;
            _this.userPageUtil.curPage = response.data.curPager;
            let list = response.data.list;
            if(list!=null && list.length > 0){

              for(let i=0;i<list.length;i++){

                let bean = list[i];
                bean.readTime = _this.$com.dateConvertTime(bean.readTime);

                if(bean.isRead == 0){
                  bean.isRead = '未读';
                }else if(bean.isRead == 1){
                  bean.isRead = '已读';
                }

              }

            }

            _this.userTableData = list;

            });

          } catch (error) {
            console.error('请求失败:', error)
          }


        },userNextClick:function(){

            _this.userPageUtil.curPage = _this.userPageUtil.curPage+1;
            _this.getUserPage();

        },userPrevClick:function(){

            _this.userPageUtil.curPage = _this.userPageUtil.curPage-1;
            _this.getUserPage();

        },userHandleSizeChange:function(val) {

            _this.userPageUtil.pageSize = val;

        },userHandleCurrentChange:function(val) {

            _this.userPageUtil.curPage = val;
            _this.getUserPage();

        }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/SysNotice.vue